import { render } from "./NAttachmentsListItem.vue?vue&type=template&id=2a8c8c10&ts=true"
import script from "./NAttachmentsListItem.vue?vue&type=script&lang=ts"
export * from "./NAttachmentsListItem.vue?vue&type=script&lang=ts"

import "./NAttachmentsListItem.vue?vue&type=style&index=0&id=2a8c8c10&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__